/**
 * Client Location Permissions
 *
 * Permissions for client location request management
 */
enum ClientLocationPermission {
  /**
   * Can create location requests, view only own requests, delete own pending requests
   */
  Prem_Location_Add = 'Prem_Location_Add',

  /**
   * Can view all requests, approve/reject pending requests, view statistics
   */
  Prem_Location_Approve = 'Prem_Location_Approve',
}

export default ClientLocationPermission;
